import { Controller } from "@hotwired/stimulus"
import { attachNavTooltips } from "../lib/nav_tooltips"

// Handles global sidebar expand/collapse with persistence via AJAX.
//
// Usage:
//   <div data-controller="sidebar"
//        data-sidebar-collapsed-class="sidebar-collapsed"
//        data-sidebar-expanded-width-value="220"
//        data-sidebar-collapsed-width-value="64"
//        data-sidebar-url-value="/en/users/1/update_settings">
//     <button data-action="sidebar#toggle">Toggle</button>
//   </div>

export default class extends Controller {
  static values = {
    expandedWidth: { type: Number, default: 220 },
    collapsedWidth: { type: Number, default: 64 },
    url: String,
    collapsed: { type: Boolean, default: false }
  }

  connect() {
    this._applyState()
    // Larry 2026-08-06 / 2026-08-11: every icon on the rail explains itself on
    // hover with the page name — instant styled tooltip, not the browser's
    // slow native one. (The old _titleNavIcons queried .project-nav-item /
    // .company-nav-item, neither of which exists on this rail, so it never
    // showed anything.) Only appears while labels are hidden.
    this._detachTips = attachNavTooltips(this.element, ".sidebar-nav-item")
  }

  disconnect() {
    this._detachTips?.()
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    this._applyState()
    this._persist()
  }

  _applyState() {
    const sidebar = this.element

    if (this.collapsedValue) {
      sidebar.style.width = `${this.collapsedWidthValue}px`
      sidebar.classList.add("sidebar-collapsed")
    } else {
      sidebar.style.width = `${this.expandedWidthValue}px`
      sidebar.classList.remove("sidebar-collapsed")
    }
  }

  _persist() {
    if (!this.hasUrlValue) return

    const mode = this.collapsedValue ? "menu-closed" : "menu-opened"
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({ setting: { global_menu_mode: mode } })
    }).catch(() => {
      // Silently fail — sidebar state is cosmetic
    })
  }
}
